<template>
  <main class="subscription">
    <section class="subscription-head">
      <div class="subscription-head_text">
        <div class="subscription-head__subtitle">Российская общественная некоммерческая<br/>
          организация Экспертный центр ПАУ</div>
        <div class="subscription-head__title">Решим любой вопрос без обращения к юристам</div>
        <div class="subscription-head__subsubtitle">Одна подписка - много возможностей</div>
        <button class="subscription-head_btn"><a href="#ya1">Оформить подписку</a></button>
      </div>
      <div class="subscription-head_image">
        <svg width="469" height="400" viewBox="0 0 469 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="8" width="453" height="384" stroke="url(#paint0_linear)" stroke-width="16"/>
          <defs>
            <linearGradient id="paint0_linear" x1="46.8693" y1="64.7221" x2="252.365" y2="501.864" gradientUnits="userSpaceOnUse">
              <stop stop-color="#F19222"/>
              <stop offset="0.2731" stop-color="#F39D1B"/>
              <stop offset="1" stop-color="#F9B60B"/>
            </linearGradient>
          </defs>
        </svg>
        <img src="../../static/assets/img/subscribe/evgeni.png" alt="">
      </div>
    </section>
    <section class="subscription-what">
      <div class="subscription-what_title">
        <p>Что даёт подписка?</p>
        <p>
          Верните деньги за товар, купленный в интернет-магазине, и водительские права;
          оспорьте штраф с камер и взыскание долга, превышающего 50% от дохода;
          восстановитесь на работе, если Вас незаконно уволили;
          получите кредитные каникулы по ипотеке или автокредиту;
          заставьте работодателя заключить трудовой договор; выиграйте суд со страховой компанией по
          ОСАГО и решите еще десятки других вопросов всего от 3400 рублей.
        </p>
        <div class="subscription-what_title-icon">
          <div>Более эффективное решение правовых вопросов</div>
          <div>Более быстрый поиск
            вариатов решений</div>
          <div>Экономию
            денежных средств</div>
        </div>
      </div>
      <div class="subscription-what_video">
        <iframe src="https://www.youtube.com/embed/dq87AJE2bF8"></iframe>
      </div>
    </section>
    <section class="subscription-spec">
      <div class="subscription-spec_avatar"><img src="../../static/assets/img/subscribe/anna.png" alt=""></div>
      <div class="subscription-spec_title">
        <p>Анна Резниченко<br/><span>Методолог Академии СМАРТ.юрист, ведущая топ-5 программ обучения</span></p>
        <p>
          Сегодня мы предложили, пожалуй, лучшее решение для наших клиентов, столкнувшихся с разнообразными юридическими
          проблемами. Один раз оформляется подписка, и вы всегда защищены от ГИБДД, от недобросовестных страховщиков,
          работодателей, продавцов, семейных и кредитных неприятностей, которые могут случиться с каждым.<br>
          Мы сделали стоимость подписки не просто доступной, а действительно выгодной. Например, оспаривание незаконного
          увольнения вам обойдется всего в 3400 рублей, в то время как аналогичная работа юристов стоит от 10000 рублей,
          а ведь увольнение с работы – это еще и потеря дохода и, возможно, на длительное время.
        </p>
      </div>
    </section>
    <section class="subscription-questions_wrapper">
      <div class="subscription-questions">
        <p>Какие решения Вы получите?</p>
      </div>
      <div class="subscription-questions_container">
        <div class="subscription-questions_box">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32.6672 4.95703H3.33281C1.49766 4.95703 0 6.45469 0 8.28984V27.7102C0 29.5453 1.49766 31.043 3.33281 31.043H32.6672C34.5023 31.043 36 29.5453 36 27.7102V8.28984C36 6.45469 34.5023 4.95703 32.6672 4.95703ZM34.3125 27.7102C34.3125 28.6172 33.5742 29.3555 32.6672 29.3555H3.33281C2.42578 29.3555 1.6875 28.6172 1.6875 27.7102V8.28984C1.6875 7.38281 2.42578 6.64453 3.33281 6.64453H32.6672C33.5742 6.64453 34.3125 7.38281 34.3125 8.28984V27.7102ZM13.9289 17.5148C14.4211 16.875 14.6883 16.0945 14.6953 15.2648C14.7023 14.2664 14.3156 13.3242 13.6125 12.6211C12.9164 11.925 11.9531 11.5312 10.9688 11.5312C9.99141 11.5312 9.04219 11.925 8.35313 12.6141C7.64297 13.3102 7.24922 14.2523 7.24219 15.2508C7.24219 16.0805 7.50234 16.868 7.99453 17.5078C5.97656 18.1336 4.5 20.018 4.5 22.2328V23.625C4.5 23.85 4.59141 24.0609 4.74609 24.2227C4.90781 24.3773 5.11875 24.4688 5.34375 24.4688L16.5867 24.4477C17.0508 24.4477 17.4305 24.068 17.4305 23.6039V23.0414C17.4516 21.7195 17.4727 20.2148 15.9891 18.7383C15.4125 18.1687 14.7023 17.7469 13.9289 17.5148ZM9.54141 13.8164C9.92109 13.4367 10.4414 13.2188 10.9688 13.2188C11.5102 13.2188 12.0375 13.4367 12.4172 13.8164C12.7969 14.1961 13.0078 14.7094 13.0078 15.2578C13.0078 15.8062 12.7898 16.3195 12.3961 16.7063C12.0094 17.093 11.5031 17.3039 10.9688 17.3039C10.4273 17.3039 9.9 17.0859 9.52031 16.7063C9.14062 16.3266 8.92969 15.8133 8.92969 15.2648C8.92969 14.7094 9.14766 14.1961 9.54141 13.8164ZM15.75 22.7602L6.1875 22.7812V22.2328C6.1875 20.4398 7.65 18.9844 9.44297 18.9844H12.4875C13.3523 18.9844 14.1891 19.3289 14.7937 19.9336C15.6727 20.8055 15.757 21.5648 15.75 22.7602ZM31.2188 13.7812C31.2188 14.2453 30.8391 14.625 30.375 14.625H21.6562C21.1922 14.625 20.8125 14.2453 20.8125 13.7812C20.8125 13.3172 21.1922 12.9375 21.6562 12.9375H30.375C30.8391 12.9375 31.2188 13.3172 31.2188 13.7812ZM31.2188 18C31.2188 18.4641 30.8391 18.8438 30.375 18.8438H21.6562C21.1922 18.8438 20.8125 18.4641 20.8125 18C20.8125 17.5359 21.1922 17.1562 21.6562 17.1562H30.375C30.8391 17.1562 31.2188 17.5359 31.2188 18ZM31.2188 22.2188C31.2188 22.6828 30.8391 23.0625 30.375 23.0625H21.6562C21.1922 23.0625 20.8125 22.6828 20.8125 22.2188C20.8125 21.7547 21.1922 21.375 21.6562 21.375H30.375C30.8391 21.375 31.2188 21.7547 31.2188 22.2188Z" fill="black"/>
          </svg>
          <p class="subscription-questions_box-title">Для защиты прав потребителей и обжалования действий пристава</p>
          <p>
            Возврат денег за некачественный товар<br/>
            Возврат денег за качественный товар, который не подошел<br/>
            Возврат денег за товар, купленный через интернет<br/>
            Значительное сокращение времени на перечисление денег взыскателю<br/>
          </p>
        </div>
        <div class="subscription-questions_box">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0)">
              <path d="M35.999 16.1156C35.6404 11.7562 33.5661 7.69219 30.163 4.66172C26.788 1.65938 22.4779 0.00703125 18.02 0H18.013C18.006 0 18.006 0 17.999 0C17.9919 0 17.9919 0 17.9849 0C17.9849 0 17.9849 0 17.9779 0C13.52 0.00703125 9.20989 1.65938 5.83489 4.66172C2.43176 7.69219 0.364575 11.7562 -0.00104961 16.1156C-0.0291746 16.4391 0.132544 16.7484 0.413794 16.9102C0.695044 17.0719 1.03958 17.0648 1.31379 16.882C3.54973 15.3844 6.93176 15.3844 9.17473 16.868C9.18176 16.875 9.1888 16.875 9.20286 16.882C9.20286 16.882 9.20286 16.882 9.20989 16.882C9.20989 16.882 9.21692 16.882 9.21692 16.8891C9.49817 17.0648 9.85676 17.0648 10.138 16.875C12.2615 15.4547 14.9755 15.3773 17.1622 16.643V32.0766C17.1622 34.2352 18.92 35.993 21.0786 35.993C23.2372 35.993 24.9951 34.2352 24.9951 32.0766C24.9951 31.6125 24.6154 31.2328 24.1513 31.2328C23.6872 31.2328 23.3075 31.6125 23.3075 32.0766C23.3075 33.307 22.3091 34.3055 21.0786 34.3055C19.8482 34.3055 18.8427 33.3141 18.8427 32.0836V16.657C21.0294 15.3914 23.7435 15.4688 25.8669 16.8891C26.0075 16.9875 26.1693 17.0297 26.338 17.0297C26.4927 17.0297 26.6544 16.9875 26.788 16.8961C26.788 16.8961 26.795 16.8961 26.795 16.8891C26.795 16.8891 26.7951 16.8891 26.8021 16.8891C26.8091 16.882 26.8161 16.882 26.8302 16.875C29.0732 15.3844 32.4552 15.3914 34.6911 16.8891C34.9583 17.0719 35.3099 17.0789 35.5911 16.9172C35.8654 16.7484 36.0201 16.4391 35.999 16.1156ZM5.23723 14.0766C4.07004 14.0766 2.92395 14.2945 1.89739 14.6953C2.5302 11.3625 4.29504 8.29688 6.95989 5.92031C9.35052 3.78984 12.2615 2.40469 15.3482 1.89844C14.0052 3.14297 12.831 4.55625 11.8607 6.12422C9.90598 9.28125 9.15364 12.4172 8.89348 14.8078C7.78255 14.3297 6.53098 14.0695 5.2513 14.0695C5.24426 14.0766 5.24426 14.0766 5.23723 14.0766ZM10.6021 14.7234C10.8622 12.5578 11.5724 9.79453 13.295 7.01719C14.3427 5.32969 15.6365 3.83203 17.1552 2.55938V14.7656C15.0669 13.8586 12.7044 13.8375 10.6021 14.7234ZM18.8427 14.7656V2.55938C20.3615 3.83906 21.6552 5.32969 22.7029 7.01719C24.4255 9.79453 25.1286 12.5578 25.3958 14.7234C23.2935 13.8375 20.931 13.8586 18.8427 14.7656ZM30.7607 14.0766C30.7536 14.0766 30.7536 14.0766 30.7466 14.0766C29.4669 14.0766 28.2083 14.3367 27.1044 14.8148C26.8443 12.4172 26.0919 9.28125 24.1372 6.13125C23.1669 4.56328 21.9997 3.15 20.6497 1.90547C23.7365 2.41172 26.6474 3.79687 29.038 5.92031C31.7029 8.28984 33.4677 11.3625 34.1005 14.6953C33.074 14.2945 31.9279 14.0766 30.7607 14.0766ZM7.8177 20.3625C3.50754 20.3625 -0.00104961 23.8711 -0.00104961 28.1812C-0.00104961 32.4914 3.50754 36 7.8177 36C12.1279 36 15.6365 32.4914 15.6365 28.1812C15.6365 23.8711 12.1279 20.3625 7.8177 20.3625ZM7.8177 34.3125C4.43567 34.3125 1.68645 31.5633 1.68645 28.1812C1.68645 24.7992 4.43567 22.05 7.8177 22.05C11.1997 22.05 13.949 24.7992 13.949 28.1812C13.949 31.5633 11.1997 34.3125 7.8177 34.3125ZM9.94817 29.5875C9.94817 30.5016 9.35755 31.2891 8.54192 31.5773V32.4C8.54192 32.7867 8.22551 33.1031 7.8388 33.1031C7.45208 33.1031 7.13567 32.7867 7.13567 32.4V31.5773C6.66458 31.4227 6.22864 31.1063 5.84895 30.6633C5.59583 30.368 5.63801 29.925 5.93333 29.6719C6.22864 29.4188 6.67161 29.4609 6.92473 29.7563C7.21301 30.1008 7.53645 30.2906 7.8388 30.2906C8.22551 30.2906 8.54192 29.9742 8.54192 29.5875C8.54192 29.2008 8.22551 28.8844 7.8388 28.8844C6.67864 28.8844 5.72942 27.9352 5.72942 26.775C5.72942 25.8609 6.32005 25.0734 7.13567 24.7852V23.9625C7.13567 23.5758 7.45208 23.2594 7.8388 23.2594C8.22551 23.2594 8.54192 23.5758 8.54192 23.9625V24.7781C8.86536 24.8836 9.21692 25.0805 9.57551 25.425C9.85676 25.6922 9.8638 26.1422 9.58958 26.4164C9.32239 26.6977 8.87239 26.7047 8.59817 26.4305C8.35208 26.1914 8.08489 26.0648 7.8388 26.0648C7.45208 26.0648 7.13567 26.3813 7.13567 26.768C7.13567 27.1547 7.45208 27.4711 7.8388 27.4711C8.99895 27.4781 9.94817 28.4273 9.94817 29.5875Z" fill="black"/>
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="36" height="36" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <p class="subscription-questions_box-title">По семейным спорам</p>
          <p>
            Защита и восстановление своих родительских прав в суде<br/>
            Взыскание алиментов на несовершеннолетних детей и родителей<br/>
            Установление и оспаривание отцовства<br/>
          </p>
        </div>
        <div class="subscription-questions_box">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.7468 34.558L30.9707 29.7819C32.1876 28.2978 32.9191 26.4056 32.9191 24.3447C32.9191 20.5463 30.4361 17.3177 27.0106 16.1923V3.05275C27.0106 1.37163 25.6319 0 23.9297 0H3.08089C1.37866 0 0 1.37163 0 3.05275V29.578C0 31.2661 1.37866 32.6377 3.08089 32.6377H22.1571C22.8535 32.8206 23.585 32.9191 24.3376 32.9191C26.3986 32.9191 28.2978 32.1876 29.7749 30.9707L34.551 35.7468C34.7128 35.9086 34.9308 35.993 35.1489 35.993C35.3669 35.993 35.578 35.9086 35.7468 35.7468C36.0774 35.4162 36.0774 34.8886 35.7468 34.558ZM3.08089 30.9496C2.31419 30.9496 1.68816 30.3376 1.68816 29.585V3.05275C1.68816 2.30012 2.31419 1.68816 3.08089 1.68816H23.9367C24.7034 1.68816 25.3294 2.30012 25.3294 3.05275V15.8124C25.0059 15.7773 24.6753 15.7562 24.3447 15.7562C19.6108 15.7562 15.7632 19.6038 15.7632 24.3376C15.7632 26.9965 16.9801 29.374 18.8793 30.9496H3.08089ZM17.4443 24.3376C17.4443 20.5393 20.5393 17.4443 24.3376 17.4443C28.136 17.4443 31.231 20.5393 31.231 24.3376C31.231 28.136 28.136 31.2309 24.3376 31.2309C20.5393 31.2309 17.4443 28.136 17.4443 24.3376ZM5.6272 12C5.6272 11.5358 6.00703 11.1559 6.47128 11.1559H19.6952C20.1594 11.1559 20.5393 11.5358 20.5393 12C20.5393 12.4642 20.1594 12.8441 19.6952 12.8441H6.47128C6.00703 12.8441 5.6272 12.4642 5.6272 12ZM14.2087 17.5217C14.2087 17.9859 13.8288 18.3658 13.3646 18.3658H6.47128C6.00703 18.3658 5.6272 17.9859 5.6272 17.5217C5.6272 17.0574 6.00703 16.6776 6.47128 16.6776H13.3646C13.8288 16.6776 14.2087 17.0574 14.2087 17.5217ZM5.6272 6.47128C5.6272 6.00703 6.00703 5.6272 6.47128 5.6272H16.0375C16.5018 5.6272 16.8816 6.00703 16.8816 6.47128C16.8816 6.93552 16.5018 7.31536 16.0375 7.31536H6.47128C6.00703 7.31536 5.6272 6.93552 5.6272 6.47128Z" fill="black"/>
          </svg>
          <p class="subscription-questions_box-title">Для защиты прав автовладельцев</p>
          <p>
            Возврат прав за выезд на встречку, управление без номеров и в состоянии опьянения,
            за причинение вреда здоровью, скрытие с места ДТП, ж/д переезды, превышение скорости и по другим основаниям<br/>
            Получение полной выплаты от страховой компании, взыскание УТС, получение возмещения за некачественный ремонт, решение других споров со страховой компанией<br/>
            Оспаривание любых штрафов, решение каршеринговых споров, споров по ДТП, с автосалоном, СТО, АЗС и др.<br/>
          </p>
        </div>
        <div class="subscription-questions_box">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.7468 34.558L30.9707 29.7819C32.1876 28.2978 32.9191 26.4056 32.9191 24.3447C32.9191 20.5463 30.4361 17.3177 27.0106 16.1923V3.05275C27.0106 1.37163 25.6319 0 23.9297 0H3.08089C1.37866 0 0 1.37163 0 3.05275V29.578C0 31.2661 1.37866 32.6377 3.08089 32.6377H22.1571C22.8535 32.8206 23.585 32.9191 24.3376 32.9191C26.3986 32.9191 28.2978 32.1876 29.7749 30.9707L34.551 35.7468C34.7128 35.9086 34.9308 35.993 35.1489 35.993C35.3669 35.993 35.578 35.9086 35.7468 35.7468C36.0774 35.4162 36.0774 34.8886 35.7468 34.558ZM3.08089 30.9496C2.31419 30.9496 1.68816 30.3376 1.68816 29.585V3.05275C1.68816 2.30012 2.31419 1.68816 3.08089 1.68816H23.9367C24.7034 1.68816 25.3294 2.30012 25.3294 3.05275V15.8124C25.0059 15.7773 24.6753 15.7562 24.3447 15.7562C19.6108 15.7562 15.7632 19.6038 15.7632 24.3376C15.7632 26.9965 16.9801 29.374 18.8793 30.9496H3.08089ZM17.4443 24.3376C17.4443 20.5393 20.5393 17.4443 24.3376 17.4443C28.136 17.4443 31.231 20.5393 31.231 24.3376C31.231 28.136 28.136 31.2309 24.3376 31.2309C20.5393 31.2309 17.4443 28.136 17.4443 24.3376ZM5.6272 12C5.6272 11.5358 6.00703 11.1559 6.47128 11.1559H19.6952C20.1594 11.1559 20.5393 11.5358 20.5393 12C20.5393 12.4642 20.1594 12.8441 19.6952 12.8441H6.47128C6.00703 12.8441 5.6272 12.4642 5.6272 12ZM14.2087 17.5217C14.2087 17.9859 13.8288 18.3658 13.3646 18.3658H6.47128C6.00703 18.3658 5.6272 17.9859 5.6272 17.5217C5.6272 17.0574 6.00703 16.6776 6.47128 16.6776H13.3646C13.8288 16.6776 14.2087 17.0574 14.2087 17.5217ZM5.6272 6.47128C5.6272 6.00703 6.00703 5.6272 6.47128 5.6272H16.0375C16.5018 5.6272 16.8816 6.00703 16.8816 6.47128C16.8816 6.93552 16.5018 7.31536 16.0375 7.31536H6.47128C6.00703 7.31536 5.6272 6.93552 5.6272 6.47128Z" fill="black"/>
          </svg>
          <p class="subscription-questions_box-title">По трудовым, корпоративным и налоговым спорам</p>
          <p>
            Оспаривание увольнения и восстановление на работе при увольнении по различным основаниям<br/>
            Получение компенсаций и задолженностей по заработной плате<br/>
            Споры по заключению трудового договора<br/>
            Минимизация рисков директора<br/>
            Снижение налога на имущество физических и юридических лиц
          </p>
        </div>
        <div class="subscription-questions_box">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M35.7468 34.558L30.9707 29.7819C32.1876 28.2978 32.9191 26.4056 32.9191 24.3447C32.9191 20.5463 30.4361 17.3177 27.0106 16.1923V3.05275C27.0106 1.37163 25.6319 0 23.9297 0H3.08089C1.37866 0 0 1.37163 0 3.05275V29.578C0 31.2661 1.37866 32.6377 3.08089 32.6377H22.1571C22.8535 32.8206 23.585 32.9191 24.3376 32.9191C26.3986 32.9191 28.2978 32.1876 29.7749 30.9707L34.551 35.7468C34.7128 35.9086 34.9308 35.993 35.1489 35.993C35.3669 35.993 35.578 35.9086 35.7468 35.7468C36.0774 35.4162 36.0774 34.8886 35.7468 34.558ZM3.08089 30.9496C2.31419 30.9496 1.68816 30.3376 1.68816 29.585V3.05275C1.68816 2.30012 2.31419 1.68816 3.08089 1.68816H23.9367C24.7034 1.68816 25.3294 2.30012 25.3294 3.05275V15.8124C25.0059 15.7773 24.6753 15.7562 24.3447 15.7562C19.6108 15.7562 15.7632 19.6038 15.7632 24.3376C15.7632 26.9965 16.9801 29.374 18.8793 30.9496H3.08089ZM17.4443 24.3376C17.4443 20.5393 20.5393 17.4443 24.3376 17.4443C28.136 17.4443 31.231 20.5393 31.231 24.3376C31.231 28.136 28.136 31.2309 24.3376 31.2309C20.5393 31.2309 17.4443 28.136 17.4443 24.3376ZM5.6272 12C5.6272 11.5358 6.00703 11.1559 6.47128 11.1559H19.6952C20.1594 11.1559 20.5393 11.5358 20.5393 12C20.5393 12.4642 20.1594 12.8441 19.6952 12.8441H6.47128C6.00703 12.8441 5.6272 12.4642 5.6272 12ZM14.2087 17.5217C14.2087 17.9859 13.8288 18.3658 13.3646 18.3658H6.47128C6.00703 18.3658 5.6272 17.9859 5.6272 17.5217C5.6272 17.0574 6.00703 16.6776 6.47128 16.6776H13.3646C13.8288 16.6776 14.2087 17.0574 14.2087 17.5217ZM5.6272 6.47128C5.6272 6.00703 6.00703 5.6272 6.47128 5.6272H16.0375C16.5018 5.6272 16.8816 6.00703 16.8816 6.47128C16.8816 6.93552 16.5018 7.31536 16.0375 7.31536H6.47128C6.00703 7.31536 5.6272 6.93552 5.6272 6.47128Z" fill="black"/>
          </svg>
          <p class="subscription-questions_box-title">По проблемам с возвратом и списанием долгов</p>
          <p>
            Споры по кредитным договорам и договорам залога с банком<br/>
            Получение кредитных каникул<br/>
            Отмена ареста имущества приставами за долги<br/>
            Взыскание долга по расписке<br/>
            Возврат долга с физических лиц<br/>
            Подготовка документов на банкротство<br/>
            Возврат страховки и навязанных банковских услуг<br/>
            Возврат дебиторской задолженности организации и др.
          </p>
        </div>
      </div>
      <div class="subscription-whom">
        <div class="subscription-whom_title">Кому и зачем это нужно?</div>
        <div class="subscription-whom_container">
          <div class="subscription-whom_box">
            <img style="width: 85px" src="../../static/assets/img/subscribe/AdobeStock_141425190.jpeg" alt="">
            <div class="subscription-whom_box-title">Вам грозит арест имущества за долги? Хотите взыскать алименты? Вернуть долг? Получить компенсацию по заработной плате?</div>
            <div class="subscription-whom_box-subtitle">
              Если Вы хотите быстро и качественно решить свой вопрос – переходите в «Расписание»,
              выбирайте дату ближайшего обучения по Вашей ситуации. Это позволит Вам отменить арест имущества
              приставами за долги, выиграть суд с банком, вернуть деньги с СТО за некачественный ремонт, защитить
              в суде свои родительские права, восстановиться на работе или решить другую проблему.
            </div>
          </div>
          <div class="subscription-whom_box">
            <img src="../../static/assets/img/subscribe/sub-whom-2.jpg" alt="">
            <div class="subscription-whom_box-title">Проверить насколько качественно юрист делает свою работу</div>
            <div class="subscription-whom_box-subtitle">
              Вы только планируете обратиться к юристу? Вас приглашают на бесплатную консультацию? Оформите подписку
              и узнайте все аспекты, тонкости и нюансы и будьте готовы проверить своего будущего юриста. Скорее всего, Вы будете намного больше знать, чем он.
              Уже обратились к юристу и заплатили немалые деньги? Проверьте, насколько ваш юрист действительно
              компетентен решить возникший вопрос. Не разводят ли Вас, пользуясь тем, что Вы не знаете законов и норм права?
            </div>
          </div>
          <div class="subscription-whom_box">
            <img src="../../static/assets/img/subscribe/sub-whom-3.jpg" alt="">
            <div class="subscription-whom_box-title">На будущее, чтобы знать свои права</div>
            <div class="subscription-whom_box-subtitle">
              В жизни может произойти все, что угодно, никто не застрахован от неприятностей. Очень важно быть готовым
              к этому. Оформить подписку и получить действительно достоверную и уникальную информацию – это лучше,
              чем часами читать многочисленные законодательные акты и статьи в Интернете и смотреть непонятные ролики,
              которые зачастую противоречат друг другу. У нас много качественно проработанных программ, посвященных
              решению конкретных юридических проблем в разных областях права.
            </div>
          </div>
          <div class="subscription-whom_box">
            <img src="../../static/assets/img/subscribe/sub-whom-4.jpg" alt="">
            <div class="subscription-whom_box-title">Начинающим юристам</div>
            <div class="subscription-whom_box-subtitle">
              Половину мест на всех обучающих программах Академии выкупают юристы – начинающие специалисты и студенты
              старших курсов. Институтское и университетское образование не дает нужных знаний, а нарабатывать опыт на
              клиентах - это неправильно! Поэтому юристы из разных уголков нашей страны обучаются на наших программах,
              что позволяет им качественно защищать своих клиентов. Привлекаете юриста или адвоката? Проверьте,
              обучался ли он в Академии Автоюрист – самом авторитетном онлайн-проекте в стране.
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="subscription-rates">
      <div class="subscription-rates_title" id="ya1">
        Тарифы
        <span>
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.4573 11.7098C15.2282 8.72707 13.8394 6.85789 12.6143 5.20844C11.4798 3.68141 10.5 2.36274 10.5 0.417502C10.5 0.261252 10.4125 0.11844 10.2738 0.0468383C10.1346 -0.0251929 9.96734 -0.013396 9.84082 0.0785571C8.00082 1.3952 6.46559 3.6143 5.9293 5.73164C5.55699 7.20574 5.50773 8.86293 5.50082 9.95742C3.8016 9.59449 3.41668 7.05278 3.41262 7.02508C3.39348 6.89324 3.31293 6.77852 3.19574 6.71586C3.07734 6.65403 2.93816 6.64953 2.81813 6.70895C2.72902 6.75207 0.631015 7.81809 0.508945 12.0744C0.50039 12.216 0.5 12.358 0.5 12.5C0.5 16.635 3.86465 19.9995 8 19.9995C8.0057 19.9999 8.0118 20.0007 8.01668 19.9995C8.01832 19.9995 8.01992 19.9995 8.02195 19.9995C12.1471 19.9877 15.5 16.6277 15.5 12.5C15.5 12.2921 15.4573 11.7098 15.4573 11.7098ZM8 19.1662C6.62141 19.1662 5.5 17.9716 5.5 16.5032C5.5 16.4532 5.49961 16.4027 5.50324 16.3409C5.51992 15.7216 5.63754 15.2989 5.76652 15.0177C6.00824 15.5369 6.44035 16.0142 7.14227 16.0142C7.37258 16.0142 7.55895 15.8278 7.55895 15.5975C7.55895 15.0043 7.57117 14.32 7.71887 13.7023C7.85031 13.1547 8.16441 12.572 8.56238 12.1049C8.73938 12.7112 9.08445 13.2018 9.42137 13.6807C9.90355 14.3659 10.402 15.0743 10.4895 16.2823C10.4948 16.3539 10.5001 16.4259 10.5001 16.5032C10.5 17.9716 9.37859 19.1662 8 19.1662Z" fill="#EF3838"/>
</svg>
            Сейчас на подписку действует специальная цена!
          </span>
      </div>
      <div class="subscription-rates_container">
        <div class="subscription-rates_box">
          <div class="subscription-rates_box-head">
            <span>Подписка</span>
            <p>На месяц</p>
          </div>
          <div class="subscription-rates_box-body">
            Сами выбираете удобные дату и время участия для решения любой задачи
            <span>Более 40 программ прямо сейчас</span>
            Скачивайте все воркбуки, инструкции, ходатайства <br/>
            Без ограничений на участие<br/>
            Записи интенсивов и вебинаров доступны для загрузки
          </div>
          <div class="subscription-rates_box-foot">
            <span>4600</span>
            <p>3400</p>
            <span>руб</span>
            <button @click="showModal(7, 'СМАРТ Подписка на месяц', null, 3400 )">Оформить</button>
          </div>
        </div>
        <div class="subscription-rates_box">
          <div class="subscription-rates_box-head">
            <span>Подписка</span>
            <p>На год</p>
          </div>
          <div class="subscription-rates_box-body">
            Сами выбираете удобные дату и время участия для решения любой задачи
            <span>Более 50 программ прямо сейчас</span>
            Доступны все обновления и новые программы<br/>
            Скачивайте все воркбуки, инструкции, ходатайства<br/>
            Передавайте доступ друзьям<br/>
            Без ограничений на участие<br/>
            Записи интенсивов и вебинаров доступны для загрузки<br/>
            Скидка 10% на помощь и участие юриста
          </div>
          <div class="subscription-rates_box-foot">
            <span>9800</span>
            <p>8900</p>
            <span>руб</span>
            <button @click="showModal(7, 'СМАРТ Подписка на год', null, 8900 )">Оформить</button>
          </div>
        </div>
        <div class="subscription-rates_box">
          <div class="subscription-rates_box-head">
            <span>Подписка</span>
            <p>Пожизненно</p>
          </div>
          <div class="subscription-rates_box-body">
            Сами выбираете удобные дату и время участия для решения любой задачи
            <span>Более 50 программ прямо сейчас</span>
            Доступны все обновления и новые программы<br/>
            Скачивайте все воркбуки, инструкции, ходатайства<br/>
            Передавайте доступ друзьям<br/>
            Без ограничений на участие<br/>
            Записи интенсивов и вебинаров доступны для загрузки<br/>
            Скидка 20% на помощь и участие юриста
          </div>
          <div class="subscription-rates_box-foot">
            <span>49600</span>
            <p>20400</p>
            <span>руб</span>
            <button @click="showModal(7, 'СМАРТ Подписка навсегда', null, 20400 )">Оформить</button>
          </div>
        </div>
      </div>
    </section>
    <section class="subscription-partners">
      <div class="subscription-partners_title">Наши партнёры</div>
      <div class="subscription-partners_container">
        <div class="subscription-partners_container-text">
          Академия СМАРТ.юрист - это сотни проверенных решений по
          автомобильным, трудовым, семейным, кредитным, долговым, налоговым спорам,
          которыми пользуются не только граждане, предприниматели, но и крупные компании.
        </div>
        <div class="subscription-partners_container-logo">
          <img src="../../static/assets/img/subscribe/01.jpg" alt="">
          <img src="../../static/assets/img/subscribe/02.jpg" alt="">
          <a href="https://онлайн-автоюрист.рф"><img width="130px" src="../../static/assets/img/subscribe/123123.png" alt=""></a>
          <img src="../../static/assets/img/subscribe/04.jpg" alt="">
          <img src="../../static/assets/img/subscribe/05.jpg" alt="">
          <img src="../../static/assets/img/subscribe/06.jpg" alt="">
          <img src="../../static/assets/img/subscribe/07.jpg" alt="">
        </div>
      </div>
    </section>
    <section class="subscription-reviews">
      <div class="subscription-reviews_title">
        Отзывы о нас
        <p>Мы становимся лучше! Ответьте на вопросы после каждого интенсива и получите подарок</p>
      </div>
      <div class="subscription-reviews_container">
        <div class="subscription-reviews_box">
          <div class="subscription-reviews_box-avatar">
            <!-- img src="../../static/assets/img/subscribe/reviews-1.jpg" alt="" -->
          </div>
          <div class="subscription-reviews_box-title">
            Василий Анисимов
            <p>г. Ярославль</p>
          </div>
          <div class="subscription-reviews_box-subtitle">
            На момент обращения в Смарт у меня были вопросы по защите моих трудовых прав, а в ближайшем будущем ожидались кредитные неприятности. Вот и решил брать оптом, т.е. сразу подписку, беда ведь не приходит одна, к сожалению. Считаю, что вебинары - это хороший вариант, когда нет возможности пользоваться услугами адвокатских. Вот уж точно: знания – сила! Обе мои ситуации разложили по полочкам, я точно знал, что делать. БлагоДарю!
          </div>
        </div>
        <div class="subscription-reviews_box">
          <div class="subscription-reviews_box-avatar">
            <!-- img src="../../static/assets/img/subscribe/reviews-2.jpg" alt="" -->
          </div>
          <div class="subscription-reviews_box-title">
            Наталия Крупицына
            <p>г. Пермь</p>
          </div>
          <div class="subscription-reviews_box-subtitle">
            Я пенсионерка, но человек активный, вожу машину. Пришел штраф за парковку, я стала искать информацию
            в сети, чтобы оспорить его, так и вышла на сайт мои-юристы. Посоветовалась с детьми, им тоже понравилась
            возможность самим научиться решать некоторые юридические вопросы. Приобрели подписку на год – и сама вопрос
            с машиной решила, и зятю-таксисту помощь будет, и дочь сразу несколько тем заинтересовали.
            Будем рекомендовать знакомым.
          </div>
        </div>
        <div class="subscription-reviews_box">
          <div class="subscription-reviews_box-avatar">
            <!-- img src="../../static/assets/img/subscribe/reviews-3.jpg" alt="" -->
          </div>
          <div class="subscription-reviews_box-title">
            Олег Сазонов
            <p>г. Новосибирск</p>
          </div>
          <div class="subscription-reviews_box-subtitle">
            Когда брал подписку на месяц, проблем в общем-то еще не было, но ожидал их. Время было, желание учиться –
            тоже, поэтому стал разбираться по трем программам на будущее. И это мне очень пригодилось! Все конкретно,
            по делу, без «воды». Сейчас подумываю продлить на год.
          </div>
        </div>
      </div>
    </section>
    <section class="subscription-faq">
      <div class="subscription-faq_title">Частые вопросы</div>
      <div class="subscription-faq__wrapper-dropdown">
        Как благодаря подписке за 8900 рублей можно не платить за кредит, если банк подал в суд за неуплату кредита?
        <ul class="subscription-faq_dropdown">
          <li>
            Подписка позволяет не только получить возможность не платить за кредит, но и решить другие споры с банком
            по кредитному договору, с ГИБДД – по возврату водительских прав, с недобросовестным продавцом – во возврату
            некачественного товара, а также юридические вопросы в других областях права – семейном, трудовом,
            налоговом и др. Благодаря интенсивам и разработанным воркбукам, которые Вы получаете, максимум за 2 часа
            с экспертом Вы сможете выработать детальный пошаговый план действий для решения самых разных юридических проблем.
            <br>8900 рублей - это оплата годовой подписки для решения любого возникшего юридического вопроса.
          </li>
        </ul>
      </div>
      <div class="subscription-faq__wrapper-dropdown">
        Где я могу найти расписание чтобы записаться?
        <ul class="subscription-faq_dropdown">
          <li>
            Проходите на главную страницу сайта мои-юристы.рф и выбирайте удобные дату и время.
            Для удобства все программы проходят несколько раз в месяц в разное время.
          </li>
        </ul>
      </div>
      <div class="subscription-faq__wrapper-dropdown">
        В каком формате проходит работа?
        <ul class="subscription-faq_dropdown">
          <li>
            Вся работа проходит в онлайн формате. Удаленка не только внесла свои коррективы, но и сделала работу
            с юристом проще, удобнее, дешевле, а, главное – эффективнее.
            Все, что Вам останется сделать, – пойти в суд или отправить готовые документы почтой. Все просто и удобно.
          </li>
        </ul>
      </div>
      <div class="subscription-faq__wrapper-dropdown">
        Сколько проблем можно решить?
        <ul class="subscription-faq_dropdown">
          <li>
            Мы собрали 450+ решений для 450+ проблем, возникающих у граждан, и постоянно работаем над увеличением
            количества программ и интенсивов, делая каждый из них эффективнее.
          </li>
        </ul>
      </div>
    </section>
    <section class="subscription-trailers">
      <div class="subscription-trailers_title">
        Трейлеры программ
        <p>Ознакомьтесь с нашими программами прямо сейчас</p>
      </div>
      <div class="subscription-trailers_container">
        <div class="swiper__wrapper" style="max-width: 100%;">
          <div class="feedback-container">
            <div class="feedback__inner">
              <div class="feedback__slide">
                <div class="feedback__box">
                  <div class="feedback__item item-feedback">
                    <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                      <div class="subscription-trailers_box-play youtube" id="RfSH-l-PlV8">
                      </div>
                      <p>Интенсив по возврату прав за нарушение на ж⁄д переездах</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="mLOlXzpTBbE">
                    </div>
                    <p>Интенсив по оспариванию незаконного снятия автомобиля с гарантии</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="n0uPo8mxOD4">
                    </div>
                    <p>Интенсив по возврату прав за превышение скорости</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="c8dwkFphvho">
                    </div>
                    <p>Интенсив по тому, как выиграть суд у каршеринга</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="kiJNG1M0Y3E">
                    </div>
                    <p>Интенсив по возврату денег за навязанные банком страховки и допуслуги</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="OwdQvOoTQQ4">
                    </div>
                    <p>Интенсив по пересмотру виновности ДТП</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="VbbDdbk5o6o">
                    </div>
                    <p>Интенсив по спорам с АЗС из-за некачественного топлива</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="MFuGNCemKV4">
                    </div>
                    <p>Интенсив по оспариванию незаконного снятия автомобиля с гарантии</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="15ZdNeRAClI">
                    </div>
                    <p>Интенсив по тому, как выиграть суд у каршеринга</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="iWi79B6IZSM">
                    </div>
                    <p>Интенсив по возврату прав за наркотическое опьянение</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="2Bx92_pVon0">
                    </div>
                    <p>Интенсив по тому, как оспорить штраф, если не пропустили пешехода</p>
                  </div>
                </div>
              </div>
              <div class="feedback__slide">
                <div class="return-slide__item item-return">
                  <div class="subscription-trailers_box" id="youtubeModalSubscribe">
                    <div class="subscription-trailers_box-play youtube" id="rG-gyBOaW4o">
                    </div>
                    <p>Интенсив по спорам с АЗС из-за некачественного топлива</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="feedback-prev">
              <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.23868 17.642L0.36249 9.8642C-0.12083 9.38691 -0.12083 8.61308 0.362491 8.13579L8.23868 0.357964C8.72201 -0.119323 9.50562 -0.119323 9.98895 0.357964C10.4723 0.835251 10.4723 1.60908 9.98895 2.08637L4.22551 7.77783L25 7.77783L25 10.2222L4.22551 10.2222L9.98895 15.9136C10.4723 16.3909 10.4723 17.1647 9.98895 17.642C9.50562 18.1193 8.722 18.1193 8.23868 17.642Z" fill="url(#paint0_linear)"/>
                <defs>
                  <linearGradient id="paint0_linear" x1="22.5016" y1="15.0875" x2="14.2668" y2="-5.66298" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F19222"/>
                    <stop offset="0.2731" stop-color="#F39D1B"/>
                    <stop offset="1" stop-color="#F9B60B"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div class="feedback-next">
              <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7613 0.357965L24.6375 8.1358C25.1208 8.61308 25.1208 9.38692 24.6375 9.8642L16.7613 17.642C16.278 18.1193 15.4944 18.1193 15.0111 17.642C14.5277 17.1647 14.5277 16.3909 15.0111 15.9136L20.7745 10.2222L0 10.2222V7.77783L20.7745 7.77783L15.0111 2.08637C14.5277 1.60909 14.5277 0.835251 15.0111 0.357965C15.4944 -0.119322 16.278 -0.119322 16.7613 0.357965Z" fill="url(#paint0_linear)"/>
                <defs>
                  <linearGradient id="paint0_linear" x1="2.49836" y1="2.91249" x2="10.7332" y2="23.663" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#F19222"/>
                    <stop offset="0.2731" stop-color="#F39D1B"/>
                    <stop offset="1" stop-color="#F9B60B"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'subscription',
  data () {
    return {
      navs: [
        'item1'
      ]
    }
  },
  methods: {
    DropDown () {
      $('.subscription-faq__wrapper-dropdown').bind('click', function () {
        $(this).toggleClass('active')
      })
    },
    initSlider () {
      // eslint-disable-next-line
      let swiper = new Swiper('.feedback-container', {
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        observer: true,
        wrapperClass: 'feedback__inner',
        slideClass: 'feedback__slide',
        observeParents: true,
        slidesPerView: 3,
        spaceBetween: 0,
        speed: 800,
        loop: true,
        navigation: {
          nextEl: '.feedback-next',
          prevEl: '.feedback-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          570: {
            slidesPerView: 1
          },
          767: {
            slidesPerView: 1
          },
          992: {
            slidesPerView: 2
          },
          1292: {
            slidesPerView: 3
          }
        }
      })
    },
    playYouTube () {
      let videos
      if (!document.getElementsByClassName) {
        videos = document.getElementsByClassName('youtube')
      } else {
        videos = document.getElementsByClassName('youtube')
      }
      let nbVideos = videos.length
      for (let i = 0; i < nbVideos; i++) {
        // Находим постер для видео по ID видео
        videos[i].style.backgroundImage = 'url(http://i.ytimg.com/vi/' + videos[i].id + '/sddefault.jpg)'
        // Размещаем над постером кнопку Play, чтобы создать эффект плеера
        let play = document.createElement('div')
        play.setAttribute('class', 'play')
        videos[i].appendChild(play)
        // По клику открыть модальное окно
        videos[i].onclick = function () {
          // Создаем iFrame и сразу начинаем проигрывать видео, т.е. атрибут autoplay=1
          let iframe = document.createElement('iframe')
          let iframeUrl = 'https://www.youtube.com/embed/' + videos[i].id + '?autoplay=1&autohide=1'
          if (this.getAttribute('data-params')) iframeUrl += '&' + this.getAttribute('data-params')
          iframe.setAttribute('src', iframeUrl)
          iframe.setAttribute('frameborder', '0')
          // Высота и ширина iFrame будет как у элемента-родителя
          iframe.style.width = this.style.width
          iframe.style.height = this.style.height
          // Заменяем начальное изображение (постер) на iFrame
          this.parentNode.replaceChild(iframe, this)
        }
      }
    },
    showModal (id, text, time, price) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
      this.$root.requestModalTime = time
      this.$root.requestModalPrice = price
    },
    createdColorHeader () {
      console.log(this.$route.path)
      $('header').css({'position': 'absolute', 'top': '0', 'right': '0', 'left': '0', 'z-index': '100', 'backgroundColor': 'initial'})
    }
  },
  mounted () {
    this.DropDown()
    setTimeout(() => { this.playYouTube() }, 1500)
    setTimeout(() => { this.createdColorHeader() }, 200)
    setTimeout(() => {
      this.initSlider()
    }, 2500)
  }
}
</script>
<style scoped>
  .subscription-head_text {
    position: relative;
  }
  .subscription-head_btn {
    margin: 20px 0 0 200px;
    background: linear-gradient(180deg, rgba(51,250,20,1) 0%, rgba(133,255,114,1) 100%);
    width: 194px;
    height: 38px;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, 0.16);
  }
  .subscription-head_btn a{
    color: #ffffff;
  }
  .subscription-trailers_box-play.youtube {
    margin-bottom: 17px;
  }
  .subscription-trailers_container .swiper__wrapper .feedback-container .feedback__inner .feedback__slide .return-slide__item{
    height: initial;
    background: initial;
    box-shadow: initial;
    overflow: initial;
    padding: 20px;
  }
  .subscription-trailers_container .swiper__wrapper .feedback-container .feedback__inner .feedback__slide .feedback__box .feedback__item{
    height: initial;
    background: initial;
    box-shadow: initial;
  }
  .subscription-trailers_container .feedback-prev {
    background: initial;
    top: 280px;
    left:calc(45% - 10px);
  }
  .subscription-trailers_container .swiper__wrapper .feedback-container {
    max-height: 280px;
  }
  .subscription-trailers_container .feedback-next {
    background: initial;
    top: 280px;
    right: calc(45% - 10px);
  }
  @media (max-width: 1150px) {
    .subscription-head {
      padding: 140px calc((100vw - 80%) / 2) 60px calc((100vw - 80%) / 2);
    }
    .subscription-what,
    .subscription-spec,
    .subscription-questions_wrapper,
    .subscription-rates,
    .subscription-partners,
    .subscription-reviews,
    .subscription-faq {
      padding: 60px calc((100vw - 80%) / 2);
    }
    .subscription-what {
      justify-content: center;
      margin-bottom: 40px;
    }
    .subscription-trailers {
      padding: 60px calc((100vw - 80%) / 2) 0 calc((100vw - 80%) / 2);
    }
    .subscription-questions_container {
      justify-content: center;
    }
    .subscription-whom_container {
      justify-content: center;
    }
    .subscription-whom_box {
      max-width: 370px;
      margin-right: 10px;
    }
    .subscription-rates_container {
      justify-content: center;
    }
    .subscription-rates_box {
      margin-bottom: 20px;
    }
    .subscription-reviews_container {
      justify-content: center;
      flex-wrap: wrap;
    }
    .subscription-reviews_box {
      max-width: 90%;
      margin-bottom: 16px;
    }
    .subscription-trailers_title p {
      display: inline-block;
    }
  }
  @media (max-width: 550px) {
    .subscription-head {
      padding: 60px calc((100vw - 80%) / 2) 0 calc((100vw - 80%) / 2);
    }
    .subscription-head_image svg {
      position: absolute;
    }
    .subscription-head_image img {
      position: relative;
      z-index: 2;
    }
    .subscription-head_btn{
      margin: 20px auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/subscription.vue